import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { CommonService } from 'src/app/services/common-services/common.service';

export interface Job {
  id: number;
  title: string,
  description: string;
  experience: string;
  location: string;
  category: string;
  summary: string;
  education: string;
  keySkills: string;
}

@Component({
  selector: 'app-career-detail',
  templateUrl: './career-detail.component.html',
  styleUrls: ['./career-detail.component.scss']
})
export class CareerDetailComponent {
  jobId!: number;
  job!: Job;
  jobs: Job[] = [];
  userForm: FormGroup;

  experienceLevels = [
    { value: 'junior', viewValue: 'Junior' },
    { value: 'mid', viewValue: 'Mid-level' },
    { value: 'senior', viewValue: 'Senior' },
    { value: 'lead', viewValue: 'Lead' }
  ];
  isModalOpen = false;
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private location: Location,
    private commonService: CommonService,
    public gtmService: GoogleTagManagerService
  ) {
    this.userForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      experience: ['', Validators.required],
      resume: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.jobId = params['id'];
      // this.job = this.jobs.find(job => job.id == this.jobId);
    });
    let apiUrl = 'assets/json/vacancy.json';
    this.commonService.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.jobs = res.data;
        this.job = this.jobs.find(job => job.id == this.jobId)!;
      }
    });
  }

  goBack() {
    this.location.back();
  }

  getRoleClass(role: string): string {
    switch (role) {
      case 'Sales':
        return 'role-sale';
      case 'Operations':
        return 'role-operations';
      case 'Sourcing':
        return 'role-src';
      default:
        return 'role-default';
    }
  }

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.userForm.patchValue({ resume: file });
      this.userForm.get('resume')?.markAsDirty();
      this.userForm.get('resume')?.markAsTouched();
    }
  }
  submitForm() {
    if (this.userForm.invalid) {
      this.userForm.markAllAsTouched(); // This will trigger validation messages on all fields
    } else {
      console.log("Form submission:", this.userForm.value);
      // Form submission logic here
    }
  }

  pushCareerApplyEvent() {
    const gtmTag = {
      event: 'Customer_Career_Apply',
      event_category: 'User Click',
      job_name: this.job.title,
      job_id: this.job.id
    };
    this.gtmService.pushTag(gtmTag);
  }

}
